/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import DrawFormEntry from '../../forms/DrawFormEntry';
import DrawDates from '../../partials/DrawDates';

import styles from '../../../../styles/items/draw-card-count.module.scss';

import voisinLockedIcon from '../../../../img/voisin/locked.svg';

interface DrawCardCountProps {
    className?: string | null;
    draw?: Draw | null;
}

function DrawCardCount({ draw = null, className = null }: DrawCardCountProps) {
    const themeClassName = useThemeClassName(styles);

    const { handle, title, participationsCount = 0, formEntry = null } = draw || {};
    const { value: formEntryValue = null } = formEntry || {};

    return (
        <div className={classNames([styles.container, themeClassName, styles[handle], className])}>
            <div className={styles.inner}>
                <div
                    className={classNames(styles.amount, {
                        [styles.locked]: formEntry !== null && formEntryValue === null,
                    })}
                >
                    <span className={styles.number}>{participationsCount}</span>
                    {formEntry !== null && formEntryValue === null ? (
                        <span className={styles.lockedIcon}>
                            <img src={voisinLockedIcon} alt="Locked" />
                        </span>
                    ) : null}
                </div>
                <div className={styles.content}>
                    <div className={styles.participations}>
                        <FormattedMessage
                            defaultMessage="Total entries for the {title} draw"
                            description="Draw card label"
                            values={{
                                title: <strong>{(title || '').toLowerCase()}</strong>,
                            }}
                        />
                    </div>
                    <DrawDates
                        draw={draw}
                        withoutBatch
                        className={styles.dates}
                        batchClassName={styles.batch}
                    />
                </div>
            </div>
            {formEntry !== null ? (
                <DrawFormEntry draw={draw} {...formEntry} className={styles.formEntry} />
            ) : null}
        </div>
    );
}

export default DrawCardCount;
